import { any, date, enums, number, object, omit, optional, string } from 'superstruct'
import { PROVIDERS } from '../constants.js'
import { defaultedNull } from './utils.js'

const OrderAsset = object({
  amount: defaultedNull(number(), 0),
  asset: optional(string()),
})

const Order = object({
  createdAt: date(),
  depositWalletAddress: defaultedNull(string(), null),
  extraFee: defaultedNull(number(), 0),
  fee: defaultedNull(number(), 0),
  from: OrderAsset,
  id: string(),
  networkFee: defaultedNull(number(), 0),
  paymentMethod: optional(string()),
  paymentMethodType: optional(string()),
  provider: enums(Object.values(PROVIDERS)),
  providerId: string(),
  rate: defaultedNull(number(), 0),
  status: string(),
  subProvider: optional(string()),
  subProviderId: optional(string()),
  to: OrderAsset,
  totalFee: defaultedNull(number(), 0),
  txId: optional(any()),
  updatedAt: date(),
  walletAddress: defaultedNull(string(), null),
})

export const SellOrder = omit(Order, ['networkFee', 'paymentMethod'])

export const BuyOrder = omit(Order, ['depositWalletAddress'])
